module.exports = __webpack_public_path__ + "96f032a35bc48bfced47e64cd02e581f.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Mission/images/img_mission_value03.svg
// module id = 1272
// module chunks = 7